// extracted by mini-css-extract-plugin
module.exports = {"container":"Ca_container__1nkfE","synthesis":"Ca_synthesis__18TB4","block":"Ca_block__2CAze"};